module.exports = __webpack_public_path__ + "img/1.5cdd1e01.png";